import React, { useEffect } from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import ProfileMenu from "./ProfileMenu";

export default function HRMain({ jobs, addJob, editJob, toggleJobVisibility }) {
  const location = useLocation();
  const currentPath = location.pathname;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPath]);

  // Helper to render sidebar items with active style based on current pathname
  const sidebarItem = (path, label) => (
    <Link
      to={path}
      style={{
        textDecoration: "none",
        color: currentPath === path ? "#236ef2" : "#26315c",
        background: currentPath === path ? "#eaf3ff" : "transparent",
        cursor: "pointer",
        fontWeight: 700,
        padding: "18px 38px",
        borderRadius: 10,
        margin: "6px 6px 0 6px",
        fontSize: 17,
        display: "block",
        transition: "background 0.25s"
      }}
    >
      {label}
    </Link>
  );

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f2f6fb" }}>
      {/* Sidebar Navigator */}
      <div
        style={{
          width: 210,
          background: "#f5f8fc",
          borderRight: "1.5px solid #e2e6ec",
          paddingTop: 48,
          minHeight: "100vh",
          position: "sticky",
          top: 0,
          alignSelf: "flex-start"
        }}
      >
        {sidebarItem("/hr", "HR Dashboard")}
        {sidebarItem("/hr/viewjobs", "View Jobs")}
        {sidebarItem("/hr/postjob", "Post a Job")}
        {/* {sidebarItem("/calendar", "Calendar")} */}
        {sidebarItem("/hr/uploadresume", "Upload Resume")}

        {/* Sidebar Profile & Logout */}
        {/* <div style={{ marginTop: "auto", padding: "0 10px 24px 10px" }}>
          <ProfileMenu />
        </div> */}
      </div>

      {/* Main Content rendered by nested routes */}
      <div style={{ flex: 1, minHeight: "100vh" }}>
        <Outlet context={{ jobs, addJob, editJob, toggleJobVisibility }} />
      </div>
    </div>
  );
}
